<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="16">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>User Info</span>
          </div>
          <div v-for="(o, index) in UserinfoList" :key="index" class="text-item">
            <span class="name">{{ o["name"] }}</span>
            <span class="val">{{ o["val"] }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'user',
  data() {
    return {
      downUrl: "",
      activeName: ["1", "2", "3", "4"],
      info: {
        UserInfo:{}
      },     
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    UserinfoList() {
      let arr = [];
      for (let i in this.info.UserInfo) {
        if (i !== "pwd") {
          arr.push({
            name: i,
            val: this.info.UserInfo[i] || "--",
          });
        }
      }
      return arr;
    },
  },
  mounted() {
    this.$http({
      url: "/api/user/queryUserInfoByName",
      params: {
        username: this.$route.query.username,
      },
    }).then((res) => {
      this.info = res.data.data;
    });
  },
};
</script>

<style scoped>

</style>